import { toast } from "sonner";
import { backupFile } from "../../api/backups";
import { backupFilename, saveBlob } from "../../native/saveFile";

// تنزيل ملف النسخة إلى جهاز المستخدم باسم يحمل اسم الشركة وتاريخ النسخة.
export const downloadBackup = async (backup, t) => {
  const blob = await backupFile(backup.id);
  const saved = await saveBlob(blob, backupFilename(backup.company_serial || backup.company_name, backup.at));
  toast.success(t(`backups.savedTo.${saved.place}`, { filename: saved.filename }), { duration: 9000 });
};
